<template>
    <b-container 
        class="bv-example-row" 
        style="margin-bottom: 64px; min-height: 50vh"
    >
        <b-row  class="my-3" style="width: 320px; margin: auto;">
            <b-col>
                <h3>Register Device</h3>
            </b-col>
        </b-row>

        <b-row class="my-3" style="width: 320px; margin: auto;">
            <b-col style="width:1000px">
                <b-input-group class="mt-3">
          <b-form-input v-model="searchString" placeholder="enter IMEI"/>
          <b-input-group-append>
            <b-button variant="info" @click="findDevice()">Search</b-button>
          </b-input-group-append>
        </b-input-group>
        </b-col>
        </b-row>
       <!-- 
       <b-row  class="my-3" style="width: 320px; margin: auto;">
            <b-col>
               <b-link to="/verify/qr">
                   OR - Use the QR Reader
               </b-link>
            </b-col>
        </b-row>
        -->

        <b-row  class="my-3" style="width: 320px; margin: auto;">
            <b-col style="padding-right: 0px; padding-left: 60px;">
                <img 
                    src="/MeterDog.png" 
                    width="100%" 
                    style="max-width: 240px"
                >
            </b-col>
        </b-row>
		<b-row  v-if="itemsNotEmpty">
			<b-col>
          <b-table
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="consts.general.rows_per_page"
              striped
              :busy="loading"
              show-empty
              id="device-table">
              <template slot="id" slot-scope="device">
                  <router-link
                      :to="{ name: 'device_detail', params: { id: device.item.id }}"
                      :id="'device-id-' + device.item.name"
                  >{{device.item.id}}</router-link>
              </template>

              <template slot="customer_account_id" slot-scope="device">
                  <router-link :to="{ path: 'account/' + device.item.customer_account_id }">
                      {{device.item.customer_account_id}}
                  </router-link>
              </template>

              <template slot="install_account_id" slot-scope="device">
                  <router-link :to="{ path: 'account/' + device.item.install_account_id }">
                      {{device.item.install_account_id}}
                  </router-link>
              </template>

            <template slot="created_date" slot-scope="date">
              {{ date.value | formatDateTime }}
            </template>

              <template slot="action" slot-scope="device">
                  <router-link :to="{ path: 'device/' + device.item.id }">Edit</router-link> -
                  <a
                      href="#"
                      @click.prevent="deleteDevice(device.item.id)"
                      :id="'delete-device-' + device.item.name"
                  >Delete</a>
              </template>

              <template slot="table-busy">
                  <div class="text-center text-primary my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong style="margin-left:20px">Loading...</strong>
                  </div>
              </template>

          </b-table>
          <b-row v-if="items">
              <b-col>
                  <b-pagination v-if="items.length > consts.general.rows_per_page"
                      v-model="currentPage"
                      :total-rows="items.length"
                      :per-page="consts.general.rows_per_page"
                      align="center"
                  >
                  </b-pagination>
              </b-col>
          </b-row>
			</b-col>
		</b-row>

        <b-row class="mb-2" style="text-align:center">
            <b-col >
                 <b-button 
                    block 
                    variant="success"
                    style="width:40%; margin:auto; height: 48px; padding-top: 11px"
                    :disabled="!selected_device" 
                    :to="`/verify/${selected_device ? selected_device.imei : null}`"
                > Continue </b-button>
            </b-col>
        </b-row>
        <b-row class="mb-2" style="text-align:center">
            <b-col >
                 <b-button 
                    block 
                    variant="light"
                    style="width:40%; margin:auto; height: 48px; padding-top: 11px"
                    @click="cancelSelfInstall()"
                > Cancel Installation </b-button>
            </b-col>
        </b-row>

    </b-container>
</template>

<script>
    import deviceApi from '../../device_apis'

    import SearchSelect from '../../widgets/SearchSelect'
    import { self_install_device_fields } from '../models/devices'



    export default {
        name: 'SelectDevice',
        components: { SearchSelect },

        props:{
            //userData:{ type: Object, required: true }
        },        

        data(){
            return {
                selected_device: null,
                available_devices: [],
                searchString: null,
                loading: false,
                // searchType: null,
                // searchStatus: null,
                // installStatus: null,
                items: [],
                itemsNotEmpty: false,
                totalRows: 1,
                perPage: 10,
                model: {},
                fields: self_install_device_fields,
                currentPage: 1,
                pages: [],
            }
        },
        created() {
            this.self_install()
            this.$emit('self_install', true)
        },
        methods: {
            async findDevice() {
                this.items = []
                this.selected_device = null
                this.available_devices = []
                console.log("get device, search string: ", this.searchString)
                try {
                    const deviceFound = await deviceApi.searchDevices({
                        search_string: this.searchString,
                        device_type: null,
                        device_status: null,
                        install_status: "ready",
                    })
                    if (deviceFound.status_code === 200) {
                        this.$emit('showAlert', 'Found device', 'success', 2100)
                    }
                    if (deviceFound.data.length === 0) {
                        this.$emit('showAlert', 'Device not found, or not available for installation', 'danger', 5000)
                    }
                    this.items = deviceFound.data
                    this.itemsNotEmpty = true
                    this.totalRows = this.items.length
                    this.currentPage = 1

                    if (this.totalRows == 1) {
                        this.selected_device = this.items[0]
                        this.available_devices = deviceFound.data
                    }
                } catch (e) {
                    e.response && e.response.data && e.response.data.message
                        ? this.$emit('showAlert', e.response.data.message, 'danger', 5000)
                        : this.$emit('showAlert', 'Found more than one device, try again', danger, 5000)
                }
            },
            self_install() {
                localStorage.setItem('authenticated', true)
                localStorage.setItem('self_install_user', true)
                this.$emit('self_install', true)
                this.$emit('setAuthenticated', true, {"email":"","userId":0,"accountId":0,"roleCode":"SIU","firstName":"Self Install","lastName":"User","accountStatus":"P"})
                this.$emit('activate_user', true)
                localStorage.setItem('active_user', true)
                localStorage.setItem('user', 
                    JSON.stringify({"email":"","userId":0,"accountId":0,"roleCode":"SIU","firstName":"Self Install","lastName":"User","accountStatus":"P"}))
            },
            cancelSelfInstall(){
                localStorage.clear()
                window.location.replace("http://konametrix.com")
            },
        }
    }

</script>

<style/>
